module.exports = __webpack_public_path__ + "static/media/G1-23-Yrís-Hatzis-cod54.91d4bbd0.png";